module.exports = __webpack_public_path__ + "static/media/wing-left.56b9d019.svg";